export default __webpack_public_path__ + "static/media/prognos_grafiskt_element.99a82cec.png";